export const QUESTION_TYPES = Object.freeze({
    SINGLE_CHOICE: 'OnlyChoice',
    MULTIPLE_ANSWERS: 'MultipleChoice',
    LIKERT_SCALE: 'LikertScale',
    OPEN_QUESTION: 'OpenQuestion',
    SORTING: 'Sorting',
    MATCHING: 'Matching',
    GAPS_IN_TEXT: 'GapsInTheText',

    /**
     * TODO удалить, оставить GAPS_IN_TEXT, так как лучше отражает суть
     *      оставлено для совместимости
     * @deprecated use GAPS_IN_TEXT
     */
    TEXT_MATCH: 'GapsInTheText',
});

export const QUESTION_TYPES_INTERVIEW = [
    QUESTION_TYPES.SINGLE_CHOICE,
    QUESTION_TYPES.MULTIPLE_ANSWERS,
    QUESTION_TYPES.LIKERT_SCALE,
    QUESTION_TYPES.OPEN_QUESTION,
    QUESTION_TYPES.GAPS_IN_TEXT,
    QUESTION_TYPES.SORTING,
];

export const QUESTION_TYPES_TEST = [
    QUESTION_TYPES.SINGLE_CHOICE,
    QUESTION_TYPES.MULTIPLE_ANSWERS,
    QUESTION_TYPES.GAPS_IN_TEXT,
    QUESTION_TYPES.SORTING,
    QUESTION_TYPES.MATCHING,
];

export const TestQuizTypes = Object.freeze({
    TEST: 'test',
    INTERVIEW: 'interview',
});

export const MicroTestOrQuizTitle = {
    [TestQuizTypes.TEST]: 'Микротест',
    [TestQuizTypes.INTERVIEW]: 'Микроопрос',
};

export const REACTION_TYPES = {
    NONE: 'none',
    EVERY: 'every',
    OVERALL: 'overall',
};

export const LIKERT_SCALE_TYPES = {
    NUMBER: 'number',
    TEXT: 'text',
    TEXT_WITH_NUMBER: 'text-with-number',
};

export const QuestionsResultsType = Object.freeze({
    USER_ONLY: 'userOnly',
    USER_AND_RIGHT: 'userAndRight',
    NONE: 'none',
});

export const SummaryReactionTypes = Object.freeze({
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
});

export const QUESTION_TYPES_TEXT = Object.freeze({
    [QUESTION_TYPES.SINGLE_CHOICE]: 'Единичный выбор',
    [QUESTION_TYPES.MULTIPLE_ANSWERS]: 'Множественный выбор',
    [QUESTION_TYPES.LIKERT_SCALE]: 'Шкала Ликерта',
    [QUESTION_TYPES.OPEN_QUESTION]: 'Открытый вопрос',
    [QUESTION_TYPES.SORTING]: 'Сортировка',
    [QUESTION_TYPES.MATCHING]: 'Установка соответствия',
    [QUESTION_TYPES.GAPS_IN_TEXT]: 'Пропуски в тексте',
});

export const QUESTION_TYPES_FOR_DISABLE_SHAKE_ANSWERS = [
    QUESTION_TYPES.LIKERT_SCALE,
    QUESTION_TYPES.SORTING,
    QUESTION_TYPES.OPEN_QUESTION,
];

export const MAX_HOURS = 12;
export const MAX_MINIMUM_ANSWERS_LEVEL = 100;
export const MIN_ANSWERS_LEVEL_DEFAULT = MAX_MINIMUM_ANSWERS_LEVEL;
export const MAX_QUESTION_TITLE = 175;
export const MAX_QUESTION_DESCRIPTION = 300;
export const MAX_ANSWERS = 10;
export const MIN_ANSWERS = 2;
export const MIN_ANSWERS_GAP_IN_TEXT = 1;
export const MAX_LENGTH_ANSWER = 300;
export const MAX_LENGTH_COMMENT = 300;
export const MAX_LENGTH_ANSWER_LIKERT = 50;
export const MAX_LENGTH_ANSWER_MATCHTEXT = 50;
export const MAX_LENGTH_ANSWER_GAPSTEXT = 50;
export const MIN_ANSWER_MATCHING_COUNT = 4;

export const MATCHING_QUESTION_COLUMN_TYPES = {
    RIGHT: 'right',
    LEFT: 'left',
};

export const SHAKE_ANSWER_DISABLED_TOOLTIP = {
    default: 'Выдавать ответы учащимся в случайном порядке',
    [QUESTION_TYPES.LIKERT_SCALE]: 'Нельзя задать данный параметр когда выбрана шкала Ликерта',
    [QUESTION_TYPES.OPEN_QUESTION]: 'Нельзя задать данный параметр когда выбран открытый вопрос',
    [QUESTION_TYPES.SORTING]: 'Нельзя выключить данный параметр когда выбрана Cортировка',
    [QUESTION_TYPES.GAPS_IN_TEXT]: 'Нельзя задать данный параметр когда выбрано дополнение к тексту',
};

export const QUESTION_TYPES_WITH_BLOCK_TYPE = {
    [TestQuizTypes.TEST]: [
        QUESTION_TYPES.SINGLE_CHOICE,
        QUESTION_TYPES.MULTIPLE_ANSWERS,
        QUESTION_TYPES.SORTING,
        QUESTION_TYPES.GAPS_IN_TEXT,
    ],
    [TestQuizTypes.INTERVIEW]: [
        QUESTION_TYPES.SINGLE_CHOICE,
        QUESTION_TYPES.MULTIPLE_ANSWERS,
        QUESTION_TYPES.SORTING,
        QUESTION_TYPES.LIKERT_SCALE,
        QUESTION_TYPES.OPEN_QUESTION,
    ],
};

export const VISIBILITY_SHUFFLE_ANSWERS = [
    QUESTION_TYPES.SINGLE_CHOICE,
    QUESTION_TYPES.MULTIPLE_ANSWERS,
    QUESTION_TYPES.SORTING,
    QUESTION_TYPES.MATCHING,
];

export const VISIBILITY_MIN_ANSWERS = [
    QUESTION_TYPES.MULTIPLE_ANSWERS,
    QUESTION_TYPES.TEXT_MATCH,
    QUESTION_TYPES.MATCHING,
];
